import { Box, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../../../helpers/utilityFunctions/utilityFunctions';
import { ParameterCard } from '../../../documented/ParameterCard';
import IconLoader from '../../../IconLoader';
import { TotalDistanceCardData } from './totalDistanceCardData';

interface TotalDistanceCardProps {
  data?: TotalDistanceCardData;
  onClick: (arg: string) => void;
}

const CardDetailTypography = styled(Typography)(() => ({
  fontSize: 14,
  padding: '0px 0px 0px 16px !important',
}));

const TotalDistanceCardMedia = styled(CardContent)(() => ({
  display: 'flex !important',
  flexDirection: 'column',
  flexGrow: '1 !important',
}));

const PanelDisplayBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

const TotalDistanceCard: React.FC<TotalDistanceCardProps> = ({
  data,
  onClick,
}: TotalDistanceCardProps) => {
  const { t } = useTranslation('cards');
  return (
    <ParameterCard
      title={t('totalDistance.title')}
      iconName="TotalDistance"
      popoverContent={t('totalDistance.popover')}
      onClick={() => onClick('_10MWT')}
      enabled={!isEmpty(data)}
    >
      <CardDetailTypography>
        {t('totalDistance.description')}
      </CardDetailTypography>
      <TotalDistanceCardMedia>
        <PanelDisplayBox>
          <IconLoader name="TotalDistanceCardFeet" />
          <Typography sx={{ fontWeight: 'bold', fontSize: 57 }}>
            {data ? data.value : '0'}
          </Typography>
          <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>
            {data ? data.unit : 'km'}
          </Typography>
        </PanelDisplayBox>
      </TotalDistanceCardMedia>
    </ParameterCard>
  );
};

export default TotalDistanceCard;
